<script>
    import { onMount, createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let mp4, jpg, height, webm

    let video

    const touch = () => video.play()

    onMount(() => {
        video.onloadeddata = () => {
            dispatch('load', video)
        }
    })

</script>

<svelte:window on:click={touch} />

<div style="max-height: {height}px;" class="w-full relative h-full">
    <video class="mx-auto" bind:this={video} autoplay="true" muted="true" playsinline="true" loop="true" preload="auto"
        poster={jpg}>
        <source src={webm} type="video/webm">
        <source src={mp4} type="video/mp4">
    </video>
</div>